export default __webpack_public_path__ + "static/media/copySVG.2751eb76.svg";